<template>
  <div class="modal" tabindex="-1" role="dialog" v-if="isVisible">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">作業実施解除</h5>
          <button type="button" class="btn-close" @click="closeModal"></button>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="closeModal">キャンセル</button>
          <button type="button" class="btn btn-primary" @click="registerWorkCompleteCancel">
            解除
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { reactive, ref } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { workCompleteCancel } from '@/api/axios';

export default {
  emits: ['onClose'],
  setup(_, { emit }) {
    const store = useStore();
    const router = useRouter();
    const isVisible = ref(false);
    const temporaryWorkData = reactive({
      id: null,
      year: null,
      month: null,
      confirm_worked: null,
      confirm_worked_dt: new Date().toISOString().substring(0, 10), // デフォルトで今日の日付
    });

    // 呼び出し元を保持するための変数
    const callerSource = ref('');

    const show = ({ temporaryWorkId, year, month, source }) => {
      temporaryWorkData.id = temporaryWorkId;
      temporaryWorkData.year = year;
      temporaryWorkData.month = month;
      callerSource.value = source; // 呼び出し元を保持
      isVisible.value = true;
    };

    const closeModal = () => {
      isVisible.value = false;
    };

    const registerWorkCompleteCancel = async () => {
      try {
        await workCompleteCancel(temporaryWorkData.id);
        store.dispatch('setFlashMessage', { message: '作業実施解除完了！', type: 'success' });
        // 呼び出し元に応じてパスを変更
        const path = '/temporary-works';

        router.push({
          path,
          query: { year: temporaryWorkData.year, month: temporaryWorkData.month },
        });
        closeModal();
        emit('onClose'); // 親コンポーネントに通知
      } catch (error) {
        console.error('作業実施解除エラー:', error);
      }
    };

    return {
      isVisible,
      temporaryWorkData,
      show,
      closeModal,
      registerWorkCompleteCancel,
    };
  },
};
</script>

<style scoped>
.modal {
  display: block;
  background-color: rgba(0, 0, 0, 0.5);
}

.modal-dialog {
  max-width: 500px;
}
</style>
